<template>
	<!-- style="background: #f7f8fa" -->
	<div class="class-table">
		<div ref="imageTofile">
			<div style="
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 22px;
			background: #f7f8fa;
			padding-top:16px
			
          ">
				<div style="width: 50px; height: 50px; margin-right: 15px;margin-bottom: 10px;">
					<img style="width: 50px; height: 50px;border-radius: 50%;" :src="showQiniuSuffix(logoImg)" />
				</div>
				<div style="margin-bottom: 10px;">{{ shop_name }}</div>
			</div>
			<div class="table-wrapper">
				<div class="tabel-container">
					<body>
						<table width="100%" border="0" cellspacing="0" cellpadding="0" class="tab">
							<tr>
								<td align="center" valign="middle" style="color: #666">
									<img width="40" height="40" src="./../assets/image/rili.png" alt="" />
								</td>
								<td width="13%" align="center" valign="middle" v-for="(weekNum, weekIndex) in days"
									:key="weekIndex" class="weekTd">
									<div class="th_tex" :class="weekNum.today === 1 ? 'today' : ''">
										<div>{{ weekNum.m }}.{{ weekNum.d }}</div>
										<div class="pp">{{ "周" + weekNum.wd }}</div>
									</div>
								</td>
							</tr>
							<tr v-for="(lesson, lessonIndex) in classTableData.lessons" :key="lessonIndex">
								<td align="center" valign="middle">
									<div class="time_tex" :class="!type?'tex2':type?'isTypeClass':'isTypeClass2'">
										<strong class="ss">{{ lesson }}</strong>
									</div>
								</td>
								<td align="center" valign="middle" style="width: 10% !important; "
									v-for="(course, courseIndex) in classTableData.courses" :key="courseIndex">
									<div>
										<div class="tex" style="background: white" :style="{
										  background: classTableData.courses[courseIndex][
										    lessonIndex
										  ].back_color
										    ? classTableData.courses[courseIndex][lessonIndex]
										      .back_color
										    : 'white',
										}" :class="!type?'tex2':(classTableData.courses[courseIndex][lessonIndex].project_type_name==''&&type)?'isTypeClass':'isTypeClass2'">
											<template v-if="classTableData.courses[courseIndex][lessonIndex] != ''
										    ">
												<div class="tex-a tex-a-name"
													style="font-size: 16px;margin: 6px auto 6px auto;text-align: center;">
													{{ classTableData.courses[courseIndex][lessonIndex]["project_name"] || "" }}
													{{classTableData.courses[courseIndex][lessonIndex]["dimension"] || ""}}

												</div>
												<div class="tex-a tex-a-min">

													{{
																  classTableData.courses[courseIndex][lessonIndex][
																  "time"
																  ] || ""
																}}
													min
												</div>

												<div class="tex-a">
													<div style="font-size: 14px;display: flex;align-items: center;">
														<img style="
																		  width: 16px;
																		  height: 16px;
																		  border-radius: 50%;margin-right: 6px;
																		" :src="showQiniuSuffix(classTableData.courses[courseIndex][lessonIndex]
																		  .coach_face)
																		  " alt="" />
														<div>

															{{
																		    classTableData.courses[courseIndex][lessonIndex][
																		    "coach_name"
																		    ]
																		  }}
														</div>
													</div>

												</div>

												<div style=" width: 100%;margin: 4px;">
													<div style="display: flex;align-items: center;justify-content: space-around;"
														v-if="classTableData.courses[courseIndex][lessonIndex].display_difficulty==1">
														<div style="display: flex;align-items: center;">
															<rate
																:rateScore="classTableData.courses[courseIndex][lessonIndex]['project_difficulty']">
															</rate>

														</div>

													</div>
												</div>
												<div class="corner-badge" :style="{
																  color: classTableData.courses[courseIndex][
																    lessonIndex
																  ].back_color
																    ? classTableData.courses[courseIndex][lessonIndex]
																      .back_color
																    : 'white',
																}" v-if="classTableData.courses[courseIndex][lessonIndex].project_type_name&&type">
													<div
														v-if="classTableData.courses[courseIndex][lessonIndex].project_type_name.split('').length>6">
														{{ classTableData.courses[courseIndex][lessonIndex].project_type_name.split('').slice(0,6).join('') }}
													</div>
													<div v-else>
														{{ classTableData.courses[courseIndex][lessonIndex].project_type_name }}
													</div>
												</div>
											</template>
										</div>
									</div>

								</td>
							</tr>
							<!-- <tr>
								<td style="background: #fff" >
									<div
										style="color: #000; margin: 15px 10px; white-space: pre-wrap;text-align: left;font-size: 22px;">
										{{ tips ? tips : "亲爱的会员 \n 为了确保您能够享受优质的教学体验，请注意以下事项：\n 1.提前预约，以便我们更好地安排课程。 \n 2.确认课程信息，包括时间、教师 \n 3.如不能按时上课，请提前告知我们。\n 4.如有问题或需要帮助，请随时与我们联系。" }}
									</div>
								</td>
								<td  style="background-color: #FFFFFF;" v-if="is_common == 2">
									<div class="pos-re"
										style="margin: 10px;display: flex;flex-direction: column;justify-content: flex-end;align-items: flex-end;padding-right: 15px;box-sizing: border-box;position: relative;">
										<img :src="showQiniuSuffix(logoImg)" alt=""
											style="position: absolute;width: 54px;height: 54px;border-radius: 50%;background-color: #FFFFFF;top: 33px;right: 48px;" />
										<img style="width: 120px; height: 120px" :src="QRCodeImg" />
										<span
											style="font-size: 16px;color: #000;font-weight: 600;margin-top: 10px;padding-right: 12px;text-align: center;width: 120px;">会员扫码预约</span>
									</div>
								</td>
								<td  style="background-color: #FFFFFF;" v-else>
									<div
										style="margin: 10px;display: flex;flex-direction: column;justify-content: flex-end;align-items: flex-end;padding-right: 15px;box-sizing: border-box;">
										<img style="width: 120px; height: 120px" :src="img" />
										<span
											style="font-size: 16px;color: #000;font-weight: 600;margin-top: 10px;padding-right: 12px;">会员扫码预约</span>
									</div>
									<div style="height: 20px;"></div>
								</td>
							</tr> -->
						</table>
						<div style="width: 100%;padding: 10px 10px;background-color: #fff;display: flex;">
							<div
								style="color: #000; margin: 15px 10px; white-space: pre-wrap;font-size: 22px;width: 70%;">
								{{ tips ? tips : "亲爱的会员 \n 为了确保您能够享受优质的教学体验，请注意以下事项：\n 1.提前预约，以便我们更好地安排课程。 \n 2.确认课程信息，包括时间、教师 \n 3.如不能按时上课，请提前告知我们。\n 4.如有问题或需要帮助，请随时与我们联系。" }}
							</div>
							<div class="pos-re" v-if="is_common == 2"
								style="margin: 10px;display: flex;flex-direction: column;justify-content: flex-end;align-items: flex-end;padding-right: 15px;box-sizing: border-box;position: relative;width: 30%;background-color: #FFFFFF;">
								<img :src="showQiniuSuffix(logoImg)" alt=""
									style="position: absolute;width: 54px;height: 54px;border-radius: 50%;background-color: #FFFFFF;bottom: 67px;right: 48px;" />
								<img style="width: 120px; height: 120px" :src="QRCodeImg" />
								<span
									style="font-size: 16px;color: #000;font-weight: 600;margin-top: 10px;padding-right: 12px;text-align: center;width: 120px;">会员扫码预约</span>
							</div>
							<div v-else style="width: 30%;background-color: #FFFFFF;">
								<div
									style="margin: 10px;display: flex;flex-direction: column;justify-content: flex-end;align-items: flex-end;padding-right: 15px;box-sizing: border-box;">
									<img style="width: 120px; height: 120px" :src="img" />
									<span
										style="font-size: 16px;color: #000;font-weight: 600;margin-top: 10px;padding-right: 12px;">会员扫码预约</span>
								</div>
								<div style="height: 20px;"></div>
							</div>

						</div>
						<div style="margin: 12px auto; color: #ccc;font-size: 14px;width: 100%;text-align: center;">
							可吉约课提供技术支持</div>
					</body>


				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/* eslint-disable */
	import axios from 'axios'
	import Rate from "./../components/Rate.vue";
	export default {
		components: {
			rate: Rate
		},
		data() {
			return {
				aws: "",
				selectCurrent: "tuan",
				selectIndex: -1,
				week: 0,
				days: [],
				time: "",
				today: 0,
				visible: false,
				confirmLoading: false,
				classTableData: {
					lessons: [],
					courses: [],
				},
				temps: {
					table_header: "#00BA26",
					table_day: "#f7f8f9",
					table_bg: "#cccccc",
				},
				projectList: {},
				wTip: "",
				tips: "",
				QRcode: "",
				chooseProjectVisible: false,
				loading: false,
				logoImg: "",
				shop_name: "",
				store_id: 99999, // 门店ID
				md: [],
				search: {
					store_id: 99999 * 1, // 门店ID
				},
				custom_project: localStorage.getItem("custom_project"),
				img: '',
				shop_id: 98,
				baseUrl: process.env.VUE_APP_BASE_API,
				QRCodeImg: null,
				is_common: null,
				type: false
			};
		},
		created() {
			this.classTableData.lessons = [];
			this.classTableData.courses = [];
			this.week = 0;
			// 1. 获取完整 url 参数
			let hash = window.location.hash;
			let paramsStr = hash.split('?')[1]
			let params = new URLSearchParams(paramsStr)
			// 2. 直接拿你要的参数
			this.store_id = params.get('storeId')
			this.shop_id = params.get('shopId')
			this.selectCurrent = params.get('selectCurrent')
			this.week = params.get('week')
			// let type = params.get('type')
			// if(type=='1'){
			// 	this.type = true
			// }else{
			// 	this.type = false
			// }
			this.days = this.getMondayArr(this.week);
			// this.days = this.getMondayArr(0);
			this.time = this.days[1].y + "-" + this.days[1].m + "-" + this.days[1].d;
			this.getLists();
			this.getShopTips()
			this.getShopQrcode()
			this.getQRCodeImg()
			this.getClassScheduleProjectTypeShow()
			// this.days = days;

		},


		methods: {
			addzero(num) {
				return num < 10 ? '0' + num : num
			},
			async getClassScheduleProjectTypeShow() {
				try {
					let params = {
						shop_id: this.shop_id,
						store_id: this.store_id,
					};
					let res = await axios.post(
						`${this.baseUrl}/yoga/_open/admin/getClassScheduleProjectTypeShow`,
						params, {
							headers: {
								"Content-Type": "application/x-www-form-urlencoded"
							}
						}
					);
					if (res.data.data.class_schedule_project_type_show == 1) {
						this.type = true
					} else {
						this.type = false
					}
					console.log("________", res)
				} catch (err) {
					console.log("❌ 请求失败", err);
				}
			},
			// /admin/getClassScheduleProjectTypeShow

			// 获取一周日期（周一开头）
			getMondayArr(week) {
				let today = this.getTimeArr()
				let w = today.w
				week = week ? week : 0
				let bgDay
				let endDay

				if (w === 0) {
					bgDay = week * 7 - 6
					endDay = week * 7
				} else {
					bgDay = week * 7 - w + 1
					endDay = week * 7 - w + 7
				}

				let arr = []
				for (var a = bgDay; a <= endDay; a++) {
					arr.push(this.getTimeArr(a))
				}
				return arr
			},

			// 获取时间
			getTimeArr(day) {
				let date1 = new Date()
				let date2 = new Date(date1)
				day = day ? day : 0
				date2.setDate(date1.getDate() + day)

				let y = date2.getFullYear()
				let m = date2.getMonth() + 1
				let d = date2.getDate()
				let h = date2.getHours()
				let i = date2.getMinutes()
				let s = date2.getSeconds()

				let dt = '上午'
				if (h >= 9 && h <= 11) {
					dt = '上午'
				} else if (h < 9 && h > 5) {
					dt = '早上'
				} else if (h > 11 && h < 14) {
					dt = '中午'
				} else if (h >= 14 && h < 18) {
					dt = '下午'
				} else {
					dt = '晚上'
				}

				let w = date2.getDay()
				let week = ['日', '一', '二', '三', '四', '五', '六']

				return {
					y: y,
					m: this.addzero(m),
					d: this.addzero(d),
					h: this.addzero(h),
					i: this.addzero(i),
					s: this.addzero(s),
					w: w,
					md: this.addzero(m) + '/' + this.addzero(d),
					wd: week[w],
					t: dt,
					today: day ? 0 : 1
				}
			},
			async getLists() {
				try {
					let params = {
						selectCurrent: this.selectCurrent,
						time: this.time,
						store_id: this.store_id,
						s_id: this.store_id,
						shop_id: this.shop_id,
						_t: Date.now() // 自动加时间戳防缓存
					};
					let res = await axios.post(
						`${this.baseUrl}/yoga/_open/admin/Tuan`,
						params, {
							headers: {
								"Content-Type": "application/x-www-form-urlencoded"
							}
						}
					);

					if (res.data.code == '200') {
						this.classTableData.lessons = res.data.data.lessons;
						this.classTableData.courses = res.data.data.courses;
						if (res.md) {
							this.md = res.data.data.md;
						}
						this.shop_name = res.data.data.store_name;
						this.logoImg = res.data.data.store_logo;
					}
				} catch (err) {
					console.log("❌ 请求失败", err);
				}
			},
			async getShopTips() {
				let params = {
					shop_id: this.shop_id
				}
				try {
					let res = await axios.post(
						`${this.baseUrl}/yoga/_open/admin/getShopTips`,
						params, {
							headers: {
								"Content-Type": "application/x-www-form-urlencoded"
							}
						}
					);

					if (res.data.code == '200') {
						this.tips = res.data.data.tips
						console.log(this.tips)
					}

					// 这里可以赋值数据
					// this.list = res.data
				} catch (err) {
					console.log("❌ 请求失败", err);
				}
			},
			async getShopQrcode() {
				let param = {
					shop_id: this.shop_id,
					tips: ''
				}
				try {
					let res = await axios.post(
						`${this.baseUrl}/yoga/_open/admin/getShopQrcode`,
						param, {
							headers: {
								"Content-Type": "application/x-www-form-urlencoded"
							}
						}
					);

					if (res.data.code == '200') {
						if (!this.shop_name) {
							this.shop_name = res.data.data.shop_name;
						}
						if (!this.logoImg) {
							this.logoImg = res.data.data.logo;
						}
						this.img = res.data.data.img
					}

				} catch (err) {
					console.log("❌ 请求失败", err);
				}
			},
			async getQRCodeImg() {
				let param = {
					shop_id: this.shop_id,
				}
				try {
					let res = await axios.post(
						`${this.baseUrl}/yoga/_open/admin/adminView`,
						param, {
							headers: {
								"Content-Type": "application/x-www-form-urlencoded"
							}
						}
					);

					this.is_common = res.data.data.is_common;
					if (res.data.data.is_common == 2) {
						// 单店铺
						let path =
							`/pages/client/index?store=${this.store_id}_shop_id=${this.shop_id}`
						this.QRCodeImg =
							`${this.baseUrl}/platform/miniapp/qrcodeImg?path=${path}&shop_id=1144&sign=${res.sign}&t=${res.t}`
					}

				} catch (err) {
					console.log("❌ 请求失败", err);
				}
			},

			showQiniuSuffix(str) {
				let arr = localStorage.getItem('qiniuURL') ? JSON.parse(localStorage.getItem('qiniuURL')) : [],
					boo = false
				if (arr && str) {
					arr.forEach((item, index) => {
						if (str.indexOf(item) > -1) {
							boo = true
						}
					})
				} else {
					boo = true
				}
				if (str && localStorage.getItem('qiniuImg') && boo) {
					return str + localStorage.getItem('qiniuImg')
				}
				return str
			},
			screenImage() {
				if (this.loading == true) return;
				this.loading = true;
				// 手动创建一个 canvas 标签
				const canvas = document.createElement("canvas");
				// 获取父标签，意思是这个标签内的 DOM 元素生成图片
				// imageTofile是给截图范围内的父级元素自定义的ref名称
				let canvasBox = this.$refs.imageTofile;
				// 获取父级的宽高
				const width = parseInt(window.getComputedStyle(canvasBox).width);
				const height = parseInt(window.getComputedStyle(canvasBox).height);
				// 宽高 * 2 并放大 2 倍 是为了防止图片模糊
				canvas.width = width * 2;
				canvas.height = height * 2;
				canvas.style.width = width + "px";
				canvas.style.height = height + "px";
				const context = canvas.getContext("2d");
				context.scale(2, 2);
				const options = {
					backgroundColor: null,
					canvas: canvas,
					useCORS: true,
				};
				html2canvas(canvasBox, options).then((canvas) => {
					// toDataURL 图片格式转成 base64
					let dataURL = canvas.toDataURL("image/png");
					this.downloadImage(dataURL);
				});
			},
			//下载图片
			downloadImage(url) {
				// 如果是在网页中可以直接创建一个 a 标签直接下载
				let a = document.createElement("a");
				a.href = url;
				a.download = "截图";
				a.click();
				this.loading = false;
			},


		}
	}
</script>

<style scoped>
	/* @import '//at.alicdn.com/t/c/font_4040360_09xuexfjyrgf.css'; */

	* {
		margin: 0;
		padding: 0;
		border: 0;
	}

	.class-table {
		margin: 0;
		padding: 0;
	}

	body {
		margin: 0 !important;
		/* background: #fff; */
		color: #000;
		font-size: 12px;
		font-family: "微软雅黑", "Microsoft YaHei", "Arial", "Helvetica Neue",
			"Helvetica", "Arial", "sans-serif";
	}

	a {
		text-decoration: none;
		color: #fff;
	}

	a:hover {
		color: #09bb07;
	}

	input,
	select,
	img {
		vertical-align: middle;
	}

	ul,
	li {
		list-style: none;
	}

	/* 新的弹框关闭按钮样式 */
	.site-btn {
		color: #000;
		background-color: #dbe3ff;
		border-radius: 25px;
		margin-top: 12px;
		cursor: pointer;
		padding: 5px 24px;
		font-size: 13px;
	}

	.site-btn-blue {
		color: #fff;
		background-color: #5073f5;
		border-radius: 25px;
		margin-top: 12px;
		cursor: pointer;
		margin-left: 16px;
		padding: 5px 24px;
		font-size: 13px;
	}


	.tab {
		width: 100%;
		margin: 0 auto;
		font-size: 14px;
		color: #fff;
		background: #f7f8fa;
	}

	.tab tr td {
		/* border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc; */
		padding: 0px 0px;
	}

	.tab .pp {
		font-size: 16px;
		font-weight: bold;
		margin-bottom: -5px;
	}

	/* .tab */
	.tab .tex {
		height: 156px;
		/* background: #97c3f0; */
		border-radius: 6px;
		color: #fff;
		font-size: 12px;
		margin: -3px 2px;
		position: relative;
	}

	.tex2 {
		height: 130px !important;
	}

	.tab .tex .tex-a {
		/* margin-bottom: 4px; */
		font-size: 14px;
		text-align: center;
		display: flex;
		/* align-items: center; */
		justify-content: space-around;
	}

	.tex-a-name {
		height: 50px;
		overflow: hidden;
		padding-top: 6px;
	}

	.isTypeClass {
		padding-top: 16px;
	}

	.isTypeClass2 {
		padding: 0px 5px 0px;
	}

	.tab .ss {
		margin: 0px 10px;
		color: #000;
		font-weight: 500;
		/* color: rgb(115, 120, 115); */
	}

	.th_tex {
		height: 60px;
		margin: 2px 2px;
		/* background: rgb(230, 234, 246); */
		background: #d2dfff;
		color: #3c6fec;
		/* color: rgb(193, 194, 220); */
		display: flex;
		flex-direction: column;
		justify-content: center;
		border-radius: 6px;
	}

	.time_tex {
		height: 156px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 2px 2px;
		font-weight: 500;
		/* background: rgb(237, 242, 238); */
		background: #fff;
		border-radius: 6px;
	}

	.today {
		/* background: rgb(175, 175, 239); */
		/* background: #3c6fec; */
		/* color: #fff; */
		color: #3c6fec;
	}

	.scheduling-header {
		height: 60px;
		border-left: none;
		padding: 0px 20px;
		line-height: 1;
		background: #f7f8fa;
	}

	.week-button {
		width: 90px;
		height: 40px;
		background: #ffffff;
		border-radius: 4px;
		border: 1px solid #ebedf5;
		font-size: 14px;
		font-weight: 500;
		color: #656a75;
		text-align: center;
		line-height: 38px;
	}

	.n-week-button {
		width: 90px;
		height: 40px;
		background: #ffffff;
		border-radius: 4px;
		border: 1px solid #4772ff;
		font-size: 14px;
		font-weight: 500;
		color: #4772ff;
		text-align: center;
		line-height: 38px;
	}

	.corner-badge {
		padding: 1px 8px;
		border-radius: 6px;
		background: #ffffff;
		z-index: 1;
		color: #000;
		display: inline-block;
		margin-bottom: 3px;
		font-size: 12px;
		/* 强制不换行 */
		white-space: nowrap;
		overflow: hidden;
	}

	::v-deep .el-rate__icon {
		font-size: 10px !important;
	}

	.ellipsis-none {
		white-space: nowrap;
		/* 强制不换行，只在一行显示 */
		overflow-x: hidden;
		/* 超出部分直接截断，不显示省略号 */
		text-overflow: clip;
		/* 明确指定截断方式，避免浏览器自动加省略号 */
		width: 62px;
		/* 文本宽度不超过父容器 */
	}

	.tex-a-min {
		margin-top: 6px;
	}
</style>